import { registerFeatureWithDescription } from "lib/features.js"
import { CATEGORY_QA_TESTING } from "lib/feature-category.js"

export const TOOLBOX_PLUGIN_ID = "defect-toolbox"
export const TOOLBOX_PLUGIN_NAME = "Defect Toolbox"
export const JIRA_URL = "https://sfg20.atlassian.net"

export const JIRA_BROWSE_URL = `${JIRA_URL}/browse`
export const FEATURE_FLAG_DEFECT_TOOLBOX = registerFeatureWithDescription({
    numericalId: 331,
    id: TOOLBOX_PLUGIN_ID,
    name: TOOLBOX_PLUGIN_NAME,
    category: CATEGORY_QA_TESTING,
    internalUseOnly: true,
    descriptionLines: ["Enables the Defect Toolbox"],
})

export const TOOLBOX_DEMANDS = ["admin", `$feature-${FEATURE_FLAG_DEFECT_TOOLBOX}`]

export const ELEMENTSOFAQUICKWIN = [
    "long titles",
    "long text",
    "white space",
    "screen size",
    "spelling mistake",
    "spelt incorrectly",
    "missing snackbar",
    "wording",
    "no results",
    "missing validation",
]
export function toPercent(value) {
    return `${(Number(value ?? 0) * 100).toFixed(1)}%`
}
